import React, { useContext } from 'react';
import {
  Form, Button, Divider, Toast, Icon,
} from '@roo/roo';
import '@roo/roo/theme/default/index.css';
import styled from 'styled-components';
import { saveBaseInfo } from '@assets/apis/innovate';
import { Organization } from './organization';
import { Business } from './business';
import { cols2 } from '../../_utils/config';
import { example_baseInfo } from '../../_utils/example';
import { useSimpleContext } from '../../_context';
import { Plus } from '../../_components/Plus';
import { FormHok } from '../../_components/FormHok';

const Root = styled.div`
  .form-patch {
    //min-width: 1072px;
    width: 634px;
  }
  .form-group {
    & > label {
      text-align: left;
    }
  }
  .boffin {
    position: relative;
    .delete {
      position: absolute;
      top: -10px;
      right: 100px;
    }
  }
  .req-n {
    .form-group {
      .has-error .select-input-wrapper .roo-input,
      .has-error .select-input-wrapper .form-control,
      .has-error .roo-input,
      .has-error .form-control {
        border-color: #e9eaf2 !important;
      }
      .help-block {
        display: none;
        visibility: hidden;
      }
    }
  }
`;

export const BaseInfo = function ({ }) {
  const { state } = useSimpleContext((t) => [t.innovate.iniValues, t.disabled]);
  const iniData = state.innovate.iniValues?.baseInfo;
  const formValue = iniData || { baseInfo: [{ ...example_baseInfo }] };

  return (
    <FormHok
      disabled={state.disabled}
      value={formValue}
      cols={cols2}
      alwaysUpdate={false}
      handleSave={saveBaseInfo}
    >
      {(props) => {
        const baseInfo = props.values.baseInfo || [];
        if (baseInfo.length === 0) {
          baseInfo.push({ ...example_baseInfo });
          props.setFieldValues({ baseInfo });
        }
        return (
          <Root>
            {(props.values.baseInfo || []).map((info, idx) => {
              const { values, setFieldValues } = props;
              return (
                <div className="boffin">
                  <div className="form-title">
                    {`${idx > 0 ? '联合' : ''}申报机构基础信息`}
                    <Divider />
                  </div>
                  <Organization {...props} idx={idx} values={info} />
                  <div className="form-title">
                    {`${idx > 0 ? '联合申报' : ''}机构经营信息`}
                    <Divider />
                  </div>
                  <Business values={info} orgType={info.organizationType} idx={idx} />
                  <br />
                  {idx >= 1 ? (
                    <Button
                      type="text"
                      className="delete"
                      onClick={() => {
                        baseInfo.splice(idx, 1);
                        setFieldValues({ ...values });
                      }}
                    >
                      <Icon name="trash-o" />
                      {' '}
                      删除
                    </Button>
                  ) : null}
                </div>
              );
            })}
            <Plus
              maxCount={4}
              tip="最多添加3个"
              count={baseInfo.length}
              text="添加联合申报机构"
              handlePush={() => {
                baseInfo.push({ ...example_baseInfo, uniteType: baseInfo.length === 0 ? 0 : 1 });
                props.setFieldValues({ baseInfo });
              }}
            >
              <div style={{ width: '100%', textAlign: 'center' }}>
                <span className="t-info">
                  <Icon name="info-circle-o" />
                  可添加三家以内的联合申报机构
                </span>
              </div>
            </Plus>
          </Root>
        );
      }}
    </FormHok>
  );
};
